// Automatisch von esbuild gebündelt (jsbundling-rails).
// Früher: app/javascript/packs/application.js (Shakapacker/Webpack).
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "./channels"

Rails.start()
ActiveStorage.start()

import "./controllers"